import { ComponentPropsWithoutRef, useEffect, useState } from 'react';
import TextInput from '@/components/functional/TextInput/TextInput.tsx';

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  debounce?: number;
  value: string | number;
  onChange: (value: string | number) => void;
} & Omit<ComponentPropsWithoutRef<typeof TextInput>, 'onChange' | 'value'>) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (onChange) {
        onChange(value!);
      }
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return <TextInput {...props} value={value} onChange={(e) => setValue(e.target.value)} />;
}
